class Utility{

    isNumberKey(evt)
    {
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        return !(charCode !== 46 && charCode > 31
            && (charCode < 48 || charCode > 57));
    }

    objectCopy(obj){
        return JSON.parse(JSON.stringify(obj))
    }

    degreeToMM(val,bmass){
        return (parseInt(bmass) * Math.sin(val * (Math.PI/180))).toFixed(3)
    }

    mmToDegree(val,bmass){
        return Math.atan((val / parseInt(bmass))).toFixed(3)
    }

    sumOfArray(arr){
        return arr.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
    }

    getModel(model){
        model=model.toLowerCase();
        console.log(model === 'außenecke');
        if(model === 'außenecke'){
            model="ausenecke";
        }else if(model === 't-formteil'){
            model="tformteil";
        }
        return model;
    }

}

export default new Utility();
